import { IMembership } from '../../features/memberships/membershipsSlice'
import React from 'react';

export const MembershipContext = React.createContext<IMembership | null>(null)
